/** Product rows reuse the FAQ's single-open, CSS-grid motion pattern. */
class AoctantProductAccordion extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.triggers = Array.from(this.querySelectorAll('[data-accordion-trigger]'));
    // Native buttons supply Enter/Space activation; no duplicate key handler.
    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-accordion-trigger]');
      if (!trigger || !this.contains(trigger)) return;
      const open = trigger.getAttribute('aria-expanded') !== 'true';
      this.triggers.forEach(other => this.setOpen(other, other === trigger && open));
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() {
    this.controller?.abort();
  }
  setOpen(trigger, open) {
    const panel = this.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
    if (!panel) return;
    trigger.setAttribute('aria-expanded', String(open));
    trigger.closest('.aoctant-product-details__item').classList.toggle('is-open', open);
    panel.inert = !open;
  }
}
if (!customElements.get('aoctant-product-accordion')) {
  customElements.define('aoctant-product-accordion', AoctantProductAccordion);
}
